import Vue from 'vue'
import VueMarkdown from 'vue-markdown'
import { mapGetters, mapActions } from 'vuex'
// import anime from 'animejs'

import Navigation from '@/components/Navigation'
import Textblock from '@/components/textblock'
import Collection from '@/components/collection'
import imageBlock from '@/components/imageBlock'
import Parallax from '@/components/parallax'

// SECTIONS
import defaultTemplate from '@/components/sections/defaultTemplate'
import Hero from '@/components/sections/hero'
import articleBlock from '@/components/sections/articleBlock'
import articleHero from '@/components/sections/articleHero'
import Listing from '@/components/sections/listing'
import Banner from '@/components/sections/banner'
import Grid from '@/components/sections/grid'
import pageHeader from '@/components/sections/pageHeader'
import pageFooter from '@/components/sections/pageFooter'

// conversation
import conversationBlock from '@/components/sections/conversationBlock'

// special
import specialPeopleListing from '@/components/sections/special/peopleListing'
import specialProjectTimeline from '@/components/sections/special/projectTimeline'
import specialDigitalMaturity from '@/components/sections/special/DigitalMaturity'

export default {
  props: [ 'page', 'id' ], // any @router props passed should be included here. id is used as a post/product id etc.
  components: {
    VueMarkdown,
    Textblock,
    Collection,
    imageBlock,
    Parallax,
    Navigation,
    defaultTemplate,
    Hero,
    articleBlock,
    articleHero,
    Listing,
    Banner,
    Grid,
    pageHeader,
    pageFooter,
    specialPeopleListing,
    specialProjectTimeline,
    specialDigitalMaturity,
    conversationBlock
  },
  data () {
    return {
      title: '',
      desc: '',
      image: '',
      templateId: '',
      classes: '',
      sections: {},
      pageFooter: null
    }
  },
  beforeRouteEnter (to, from, next) {
    // console.log('TO: ', to, 'FROM: ', from, 'NEXT: ', next)
    next((vm) => {
      vm.update(to, 'beforeRouteEnter')
      // console.log(from, to, next)
      // console.log(window.gtag)
      // console.log(vm.$gtm);
      vm.$gtm.trackEvent({
        event: 'interaction', // Event type [default = 'interaction'] (Optional)
        category: 'Navigate.RouteEnter',
        action: 'click',
        label: to.params.page,
        value: 1
        // noninteraction: false // Optional
      })

      // window.gtag('config', process.env.gtid, {
      //   'page_title': to.params.page,
      //   'page_path': to.fullPath
      // })
      // window.gtag('event', 'navigate', {
      //   'event_category': 'navigation',
      //   'event_label': 'click',
      //   'value': 1
      // })
    })
  },
  watch: {
    'pages': {
      handler: function (data) { // watches for pages in store to be populated/changed
        this.update(data, 'Pages watcher')
      },
      deep: true
    },
    // 'page': function (data) { // FIXME: i do not understand why this is nessecary
    //   this.update(data, 'watch @prop page')
    // },
    'appData': {
      handler: function (data) {
        this.setPageFooter(data.global)
      },
      deep: true
    },
    'page': {
      handler: function (target) {
        // console.log('page watcher ->', target);
        // console.log(window.gtag)
        // window.gtag('config', process.env.gtid, {
        //   'page_title': target,
        //   'page_path': '/' + target
        // })
        // window.gtag('event', 'navigate', {
        //   'event_category': 'button',
        //   'event_label': 'click',
        //   'value': 1
        // })
        this.update({}, 'page prop')
      }
    }
  },
  methods: {
    track () {
      // this.$ga.page(this.$root.$route.path)
    },
    catchSubmit () {
      // console.log('catchSubmit', document.querySelector('#contactform'))
      // document.querySelector("#contactform").removeEventListener('submit')
      // document.querySelector("#contactform").addEventListener('submit', function(e){
      //   e.preventDefault();
      //   console.log('----> ',e);
      // });
    },
    update (payload, src) {
      console.log(`${src} – %cUpdating page`, 'color: white; font-style: italic; border-radius: 3px; background-color: #5100D6; padding: 2px 5px')

      let data = payload != null
        ? () => {
          if (this.$root.$route.path === '/') {
            return this.pageFields('index')
          } else if (this.page != null) {
            return this.pageFields(this.page)
          } else {
            return null
          }
        }
        : null

      if (data() !== null) {
        this.setPageInfo(data())
        this.setSections(data())
      } else {
        console.warn('[_pageBase] No page data')
      }

      // update page footer as well if needed
      this.setPageFooter(this.$store.state.appData.global)
      this.catchSubmit()
    },
    ...mapActions([
      'getContentTypes',
      'getEntries',
      'getLinkedEntries',
      'getEntry',
      'getAsset'
    ]),
    pageFields (p) {
      // console.log('pageFields –', p, this.$store.state.pages)
      return this.$store.state.pages[p] || null
    },
    setPageInfo (fields) {
      // console.log('setPageInfo', fields)
      Vue.set(this, 'title', fields.title)
      Vue.set(this, 'desc', fields.description)
      Vue.set(this, 'image', fields.image)
      Vue.set(this, 'templateId', fields.templateId)
      Vue.set(this, 'classes', fields.classes)
    },
    setSections (fields) {
      // check for additional sections
      let component = this
      this.sections = {} // clear sections before updating

      if (fields && fields.sections) {
        fields.sections.forEach((d, i) => {
          // TODO get the content if the nested content is not available (i.e limit is reached) y sys.id

          // d.fields.title !== undefined
          //   ? Vue.set(component.sections, d.fields.title.replace(/ +/g, '-').toLowerCase(), d)
          //   : Vue.set(component.sections, `d.fields.template-${i}`, d)
          d.fields && Vue.set(component.sections, `${d.fields.templateId}-${i}`, d)
        })
      }
    },
    setPageFooter (fields) {
      if (fields && fields.items.length > 0) {
        // setting global page footer to be available in every scene
        Vue.set(this, 'pageFooter', fields.items[0].fields.siteFooter)
        Vue.set(this.pageFooter, 'formAction', fields.items[0].fields.newsletterForm)
      }
    },
    kebabToCamel (s) {
      return s.replace(/(-\w)/g, m => m[1].toUpperCase())
    }
  },
  computed: {
    ...mapGetters([
      'appConfig',
      'appData',
      'domain',
      'pages',
      'products'
    ])
  },
  created () {
  },
  mounted () {
    this.catchSubmit() // add listenters for form submits
    this.update(this, 'Mounted')

    // window.addEventListener('scroll', this.getScrollPos)
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.getScrollPos)
  }
}



// WEBPACK FOOTER //
// ./src/scenes/_pageBase.js